import React from 'react';

import { MatriculaLista } from 'Component/Matricula';
import SemRegistros from 'Component/SemRegistros';
import { useRecuperarMatriculasQuery } from 'Service';

const MeusEstudos = (): React.ReactElement => {
  const { data: { matriculas } = {}, isFetching } = useRecuperarMatriculasQuery(
    {
      contain: ['ProximaAula', 'Cursos.Categorias', 'Certificado'],
      sort: 'Matriculas.modificado',
      direction: 'desc',
      options: { arquivado: 0 },
    }
  );

  return (
    <div
      className="animate__animated animate__fadeIn"
      style={{ minHeight: window.outerHeight }}
    >
      <div
        className="hf-400 d-flex align-items-end pb-5"
        style={{
          backgroundImage:
            'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 100%), url(/img/meus-cursos.jpg)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          marginTop: '-130px',
        }}
      >
        <div className="container text-center">
          <h1 className="display-2 text-white">Meus estudos</h1>
          <p className="lead text-muted">
            Aqui você encontra os cursos que se matriculou está estudando!
          </p>
        </div>
      </div>
      <div className="mx-3">
        <div className="container mb-5">
          <SemRegistros
            carregando={isFetching}
            registros={matriculas?.length}
            titulo="Você ainda não começou nenhum curso"
            subtitulo="Para que os cursos apareçam nessa lista, basta procurar um curso que gostar, acessa-lo e iniciar qualquer aula!"
          />
          {matriculas?.map((matricula) => (
            <MatriculaLista
              key={`${matricula.id}-${matricula.modificado}`}
              dados={matricula}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MeusEstudos;
